import { render, staticRenderFns } from "./shengting_gangwei.vue?vue&type=template&id=e0ed137c&scoped=true"
import script from "./shengting_gangwei.vue?vue&type=script&lang=js"
export * from "./shengting_gangwei.vue?vue&type=script&lang=js"
import style0 from "./shengting_gangwei.vue?vue&type=style&index=0&id=e0ed137c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ed137c",
  null
  
)

export default component.exports